import api from '../config/axios-conf';

export const getShiftTypes = () =>
    api.get('/shift-types/all');

export const getDeletedShiftTypes = () =>
    api.get('/shift-types/deleted');

export const createShiftType = (data) =>
    api.post('/shift-types/create', data);

export const updateShiftType = (id, data) =>
    api.put(`/shift-types/${id}`, data);

export const deleteShiftType = (id) =>
    api.delete(`/shift-types/${id}`);

export const restoreShiftType = (id) =>
    api.put(`/shift-types/restore/${id}`, {});
